import { map, assign } from 'lodash';

/**
 * Visit model
 * @param visit
 *  <fields>
  <field name="VisitID" type="long" generateIfNull="true"/>
  <field name="WebsiteDefID" type="long"/>
  <field name="Experiments" type="binary"/>
  <field name="ExperimentDate" type="datetime"/>
  <field name="VisitType" type="byte" default="0" min="0" max="1"/>
  <field name="VisitActionType" type="byte" default="0" min="0" max="5"/>
  <field name="IP" type="text" size="15"/>
  <field name="UserAgent" type="text" size="255"/>
  <field name="ReverseIP" type="text" size="50"/>
  <field name="CurrentUrl" type="url"/>
  <field name="EntryUrl" type="url"/>
  <field name="RefererUrl" type="url"/>
  <field name="VisitorID" type="long"/>
  <field name="FolderID" type="long"/>
  <field name="AccountID" type="long" useAccountIDIfNull="true"/>
  <field name="VisitSeq" type="integer" default="0"/>
  <field name="PageViewCount" type="integer" default="0"/>
  <field name="VisitRef" type="text"/>
  <field name="VisitInfo" type="text"/>
  <field name="VisitName" type="text"/>
  <field name="CountryCode" type="text"/>
  <field name="City" type="text"/>
  <field name="RegionCode" type="text"/>
  <field name="AreaCode" type="integer"/>
  <field name="RelatedToItemType" type="byte"/>
  <field name="RelatedToItemID" type="long"/>
  <field name="VisitEmailAddress" type="text"/>
  <field name="VisitPhone" type="text"/>
  <field name="LastName" type="text"/>
  <field name="ChatInvitationID" type="long"/>
  <field name="ChatInvitationTemplateVariantID" type="long"/>
  <field name="InvitationItemType" type="byte"/>
  <field name="CallInvitationTemplateVariantID" type="long"/>
  <field name="VisitStatusType" type="byte" default="0"/>
  <field name="ChatStatusType" type="byte" default="0"/>
  <field name="CallStatusType" type="byte" default="0"/>
  <field name="InviteStatusType" type="byte" default="0"/>
  <field name="OperatorID" type="long"/>
  <field name="InviteDeclines" type="integer" default="0"/>
  <field name="InviteIgnores" type="integer" default="0"/>
  <field name="RefererID" type="long"/>
  <field name="RefererQuery" type="text"/>
  <field name="Created" type="created" allowsUpdates="false"/>
  <field name="Ended" type="datetime"/>
  <field name="Closed" type="datetime"/>
  <field name="Updated" type="updated"/>
  <field name="Deleted" type="datetime"/>
</fields>
 *
 * @constructor
 */
export class Visit {
  static comparator(visit1, visit2) {
    return visit1.VisitID === visit2.VisitID;
  }

  static wrap(event) {
    return new Visit(event.data);
  }

  static wrapAll(eventList) {
    return map(eventList, Visit.wrap);
  }

  constructor(visitRecord) {
    assign(this, visitRecord);
  }
}

export function factory() {
  return Visit;
}
